export const formatCNPJ = (cnpj: string) => {
  return cnpj.replace(
    /([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/g,
    '$1.$2.$3/$4-$5',
  );
};
